import { useDisclosure } from '@chakra-ui/react'
import { Dispatch, SetStateAction, useState } from 'react'

import { IHighlightsFolder } from '@/types/highlight.interface'

interface IUseDeleteHighlightFolders {
	folders: IHighlightsFolder[]
	selectedFolderIds: number[]
	setSelectedFolderIds: Dispatch<SetStateAction<number[]>>
	setIsSelectMode: Dispatch<SetStateAction<boolean>>
	deleteFolder: (folderId: number) => Promise<unknown>
}

export const useDeleteHighlightFolders = ({
	folders,
	selectedFolderIds,
	setSelectedFolderIds,
	setIsSelectMode,
	deleteFolder
}: IUseDeleteHighlightFolders) => {
	const [folderIdsToDelete, setFolderIdsToDelete] = useState<number[]>([])

	const deleteFoldersModal = useDisclosure()

	const openDeleteFolderModal = (folderId: number) => {
		setFolderIdsToDelete([folderId])
		deleteFoldersModal.onOpen()
	}

	const openDeleteSelectedFoldersModal = () => {
		setFolderIdsToDelete(selectedFolderIds)
		deleteFoldersModal.onOpen()
	}

	const confirmDeleteFolders = async () => {
		const ids = [...folderIdsToDelete]

		deleteFoldersModal.onClose()
		setFolderIdsToDelete([])

		if (!ids.length) return

		const remainingFoldersAmount = folders.filter(
			folder => !ids.includes(folder.id)
		).length

		setSelectedFolderIds(prev => prev.filter(id => !ids.includes(id)))

		if (!remainingFoldersAmount) {
			setIsSelectMode(false)
		}

		try {
			await Promise.all(ids.map(id => deleteFolder(id)))
		} catch (error) {
			console.log(error)
		}
	}

	const closeDeleteFoldersModal = () => {
		deleteFoldersModal.onClose()
		setFolderIdsToDelete([])
	}

	return {
		deleteFoldersModal,
		openDeleteFolderModal,
		openDeleteSelectedFoldersModal,
		confirmDeleteFolders,
		closeDeleteFoldersModal
	}
}
